import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './ImageMultiSelect.css';
import React, { useState } from 'react';
import { get, getDictionaryItem } from '../../utils';
import { addQueryStringMultiple, deleteQueryString } from './index';
import { useHistory } from 'react-router-dom';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
var ImageMultiSelect = function ImageMultiSelect(_ref) {
  var filter = _ref.filter,
    imageDictionary = _ref.imageDictionary,
    params = _ref.params,
    analytics = _ref.analytics,
    facets = _ref.facets,
    dictionary = _ref.dictionary,
    setFilter = _ref.setFilter,
    facetsName = _ref.facetsName,
    hits = _ref.hits,
    clearAlllFilters = _ref.clearAlllFilters,
    getFilterValue = _ref.getFilterValue;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    selectedMap = _useState2[0],
    selectCard = _useState2[1];
  var history = useHistory();
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var toggleCard = function toggleCard(id, available) {
    return function () {
      if (!available) {
        return;
      }
      tealiumClickFunc(tealiumMergeClickData(analytics.filterMeetingRoomLayoutAnalytics, params), id);
      var map = _objectSpread(_objectSpread({}, selectedMap), {}, _defineProperty2({}, id, !selectedMap[id]));
      selectCard(map);
      var selected = Object.entries(map).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          v = _ref3[0],
          s = _ref3[1];
        return s;
      }).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 1),
          v = _ref5[0];
        return v;
      });
      getFilterValue && getFilterValue(filter.name, facetsName, map);
      addQueryStringMultiple(facetsName, map, history);
      setFilter();
    };
  };
  React.useEffect(function () {
    if (clearAlllFilters) {
      deleteQueryString(facetsName, history);
      selectCard({});
      getFilterValue && getFilterValue(filter.name, facetsName, null);
    }
  }, [clearAlllFilters]);
  var mapDictionary = {
    'Banquet': 'banquet',
    'Boardroom': 'board room',
    'Cabaret': 'cabaret',
    'Classroom': 'class room',
    'Theatre': 'theatre',
    'UShape': 'u shape'
  };
  var mapImageDictionary = {
    'Banquet': 'search.banquetCapacity',
    'Boardroom': 'search.boardroomCapacity',
    'Cabaret': 'search.cabaretCapacity',
    'Classroom': 'search.classroomCapacity',
    'Theatre': 'search.theatreCapacity',
    'UShape': 'search.uShapeCapacity'
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "cards__title"
  }, get(filter, 'title.jss.value', '')), /*#__PURE__*/React.createElement("div", {
    className: "cards filter__field image-multiselect"
  }, get(filter, 'fieldNameItems.items', []).map(function (_ref6) {
    var fieldName = _ref6.fieldName,
      fieldValue = _ref6.fieldValue;
    var available = facets && facets[fieldValue.value] > 0;
    return /*#__PURE__*/React.createElement("div", {
      className: "card ".concat(selectedMap[fieldValue.value] ? 'card--selected' : '', " ").concat(!available ? 'card--not-available' : ''),
      onClick: toggleCard(fieldValue.value, available),
      tabIndex: 0,
      onKeyPress: function onKeyPress(event) {
        if (event.key === "Enter" || event.key === "NumpadEnter" || event.which === 32) {
          event.preventDefault();
          event.target.click();
        }
      }
    }, selectedMap[fieldValue.value] ? /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "13.126",
      height: "11.425",
      viewBox: "0 0 13.126 11.425"
    }, /*#__PURE__*/React.createElement("path", {
      id: "Union_35",
      "data-name": "Union 35",
      d: "M2.2,10.161,2.032,10l0,0L0,7.96,1.413,6.545,3.424,8.557,11.688,0l1.438,1.39L4.865,10l.015.016L3.464,11.425Z",
      fill: "#fff"
    })) : null, /*#__PURE__*/React.createElement("div", {
      className: "card__img"
    }, selectedMap[fieldValue.value] ? /*#__PURE__*/React.createElement("img", {
      alt: getDictionaryItem(dictionary, mapDictionary[fieldValue.value]),
      src: get(getDictionaryItem(imageDictionary, "".concat(mapImageDictionary[fieldValue.value], ".Active")), 'src')
    }) : /*#__PURE__*/React.createElement("img", {
      alt: getDictionaryItem(dictionary, mapDictionary[fieldValue.value]),
      src: get(getDictionaryItem(imageDictionary, mapImageDictionary[fieldValue.value]), 'src')
    })), getDictionaryItem(dictionary, mapDictionary[fieldValue.value]));
  })));
};
var StyledWrapper = function StyledWrapper(_ref7) {
  var children = _ref7.children,
    rtl = _ref7.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " col-12")
  }, children);
};
export default ImageMultiSelect;
var commonStyles = "c14venmq";
var ltrStyles = "lbv63rq";
var rtlStyles = "r11cd9j9";